// @flow
import React from 'react';
import PropTypes from "prop-types";
import {Modal, ModalManager, Effect} from 'react-dynamic-modal';

const propTypes = {
    onClickOk: PropTypes.func,
    onClickCancel: PropTypes.func,
    okText: PropTypes.string,
    cancelText: PropTypes.string,
    title: PropTypes.string,
    children: PropTypes.node
};

const defaultProps = {
    okText: 'OK',
    cancelText: 'Cancel'
};

class NotificationModal extends React.Component {
    constructor(props) {
        super(props);
        this.onClickOk = this.onClickOk.bind(this);
        this.onClickCancel = this.onClickCancel.bind(this);
    }

    onClickOk(e) {
        e.preventDefault();
        if (this.props.onClickOk) this.props.onClickOk();
        else ModalManager.close();
    }

    onClickCancel(e) {
        e.preventDefault();
        if (this.props.onClickCancel) this.props.onClickCancel();
        else ModalManager.close();
    }

    render() {
        return (
            <Modal effect={Effect.ScaleUp} className="modal-dialog" style={{content:{width:'300px'}}}>
                <div className="modal-header">
                    <button type="button" className="close" onClick={this.onClickCancel} aria-label="Close"><i
                        className="fa fa-times" aria-hidden="true"/></button>
                    <h4 className="modal-title">{this.props.title}</h4>
                </div>

                <div className="modal-body">
                    <p>{this.props.children}</p>
                </div>

                <div className="modal-footer">
                    <button type="button" className="btn btn-default" onClick={this.onClickCancel}>{this.props.cancelText}</button>
                    <button type="button" className="btn btn-primary" onClick={this.onClickOk}>{this.props.okText}</button>
                </div>
            </Modal>
        );
    }
}

NotificationModal.propTypes = propTypes;
NotificationModal.defaultProps = defaultProps;

export default NotificationModal;
